import React from "react";

import { api } from "api";
import { IRouteListItem, Iterable } from "types";

export const useRoutesList = () => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<Iterable<IRouteListItem>[]>([]);

  const fetchRoutes = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.route.list();
      setData(response);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    void fetchRoutes();
  }, [fetchRoutes]);

  return { loading, data } as const;
};

export const useRoute = (id: string) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<Iterable<IRouteListItem> | undefined>(
    undefined
  );

  const fetchRoutes = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.route.get({ id });
      setData(response);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }, [id]);

  React.useEffect(() => {
    void fetchRoutes();
  }, [fetchRoutes]);

  return { loading, data } as const;
};
